export enum MentalDisorder {
    MENTAL_DISORDER_INPATIENT = "Mental disorder inpatient treatment facility",
    MENTAL_DISORDER_OUTPATIENT = "Mental disorder outpatient treatment"
}